import { privateAxios } from "../../../config/apiConfig";
import {
  CREATE_SHIPPING_CHARGE_FAILURE,
  CREATE_SHIPPING_CHARGE_REQUEST,
  GET_ALL_SHIPPING_CHARGE_SUCCESS,
  GET_ALL_SHIPPING_CHARGE_REQUEST,
  GET_ALL_SHIPPING_CHARGE_FAILURE,
  DELETE_SHIPPING_CHARGE_REQUEST,
  DELETE_SHIPPING_CHARGE_FAILURE,
  UPDATE_SHIPPING_CHARGE_REQUEST,
  UPDATE_SHIPPING_CHARGE_FAILURE,
  DELETE_SHIPPING_CHARGE_SUCCESS,
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllShippingCharge = () => async (dispatch) => {
  dispatch({ type: GET_ALL_SHIPPING_CHARGE_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/shippingCharges`);
    dispatch({ type: GET_ALL_SHIPPING_CHARGE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_SHIPPING_CHARGE_FAILURE, payload: error.message });
  }
};

export const createShippingCharge = (shippingChargeData, handleCancle) => async (dispatch) => {
  dispatch({ type: CREATE_SHIPPING_CHARGE_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/shippingCharge`, shippingChargeData);
    if (data.status === "SUCCESS") {
      dispatch(getAllShippingCharge());
      toast.success(data.response);
      handleCancle();
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_SHIPPING_CHARGE_FAILURE, payload: error.message });
  }
};

export const updateShippingCharge = (shippingChargeId, shippingChargeData, handleCancle) => async (dispatch) => {
  dispatch({ type: UPDATE_SHIPPING_CHARGE_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/shippingCharge/${shippingChargeId}`,
      shippingChargeData
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllShippingCharge());
      toast.success("Additional Range Charge Updated Successfully");
      handleCancle()
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_SHIPPING_CHARGE_FAILURE, payload: error.message });
  }
};

export const deleteShippingCharge = (shippingChargeId) => async (dispatch) => {
  dispatch({ type: DELETE_SHIPPING_CHARGE_REQUEST });
  try {
    const { data } = await privateAxios.delete(`admin/shippingCharge/${shippingChargeId}`);
    if (data.status === "SUCCESS") {
      dispatch(getAllShippingCharge());
      dispatch({ type: DELETE_SHIPPING_CHARGE_SUCCESS, payload: shippingChargeId })
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_SHIPPING_CHARGE_FAILURE, payload: error.message });
  }
};
